import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { GtmBootstrapService } from './gtm-bootstrap.service';

/**
 * Registers GTM bootstrap so analytics initializes once before the app renders (OM-807).
 */
export function provideAnalytics(): EnvironmentProviders[] {
  return [
    provideAppInitializer(() => {
      inject(GtmBootstrapService).initialize();
    }),
  ];
}
